<template>
	<div class="siteUseBox">
		<div class="column">
			<div class="columnText2" style="margin-right: 0.1rem;">
				会场预定号
			</div>
			<el-input :disabled="disabled" size="small" v-model="datas.useNumber" class="columnText3"
				placeholder-class="placeholder" style="flex: 1; " placeholder="请输入会场预定号（如有）"
				type="text"></el-input>
		</div>
		<div class="column">
			<div class="columnText4" style="margin-right: 0.1rem;">
				如何使用会场
			</div>
			<div style="flex: 1;">
				<div class="columnText3" style="font-size: 22rpx;">{{ datas.useMethod ? datas.useMethod : '未填写' }}</div>
			</div>
		</div>
		<div class="column">
			<div class="columnText4" style="margin-right: 0.1rem;">
				使用说明文字描述
			</div>
			<el-input :disabled="disabled" size="small" v-model="datas.useExplain" class="columnText3" placeholder-class="placeholder"
				style="flex: 1;" placeholder="请输入使用说明文字描述" type="text"></el-input>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		datas: {
			type: Object,
			default: {}
		},
		disabled: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			init: this.datas,
			rangeList: ['您预订时提供的联系人于会场负责任联系并确认身份',
				'您预定时提供的联系人与与会场负责人联系并用voucher(预定凭证)确认身份']
		}
	},
	methods: {
		picler1Change(val) {
			this.$set(this.datas, 'useMethod', this.rangeList[val.detail.value])
		},
	},
	watch: {
		datas: {
			handler(n, o) {
				this.$emit('updateDatas', n)
			},
			deep: true
		}
	}
}
</script>

<style lang="scss" scoped>
.siteUseBox {
	border-radius: 0.05rem;
	background-color: rgba(250, 250, 250, 1);
	padding: 0 0.1rem;

	.column {
		height: 0.4rem;
		border-top: 1px dotted #E9E9E9;
		display: flex;
		align-items: center;
		justify-content: space-between;

		&:nth-child(1) {
			border-top: none;
			height: 70rpx;
		}

		.columnText2 {
			color: rgba(149, 144, 144, 1);
			text-align: center;
		}

		.columnText3 {
			color: #000000;
			text-align: center;
		}

		.columnText4 {
			color: rgba(230, 74, 25, 1);
			text-align: center;
		}

		.columnText1 {
			color: #000000;
			font-size: 0.15rem;
			text-align: center;
		}
	}
}
</style>
